<div>
  <form class="custom-bg-1" (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="row mob-mx-2">
      <ng-container *ngFor="let question of questions">
        <div
          *ngIf="isVisible(question.visibility)"
          [class]="question.className"
        >
          <app-question
            [enabled]="!uploadingFile"
            [question]="question"
            [form]="form"
            (imgData)="handleImage($event)"
            (isImage)="onImgTypeChange($event)"
            (fileData)="handleFileUpload($event)"
            (deleteLink)="handleDeleteLink($event)"
            (checkBoxChange)="checkBoxChanged($event)"
          ></app-question>
          <p-progressBar
            *ngIf="question.controlType == 'file' && uploadingFile"
            [value]="uploadProgress"
          ></p-progressBar>
        </div>
      </ng-container>
    </div>
    <div class="col-12 pt-4 d-flex justify-content-center">
      <p-button
        type="submit"
        [disabled]="!form.valid"
        dis
        [styleClass]="!form.valid ? 'p-button-danger' : 'v4-btn-every py-2'"
        [icon]="!form.valid ? 'pi pi-times-circle' : 'pi pi-check-circle'"
        label="حفظ"
      ></p-button>
    </div>
  </form>
</div>

<!-- 
  Copyright Google LLC. All Rights Reserved.
  Use of this source code is governed by an MIT-style license that
  can be found in the LICENSE file at https://angular.io/license
  -->
